import { useState, useEffect } from 'react';
import { useOutletContext } from 'react-router-dom';
import { adminApi } from '../../services/adminApi';
import { MapPin, Loader2 } from 'lucide-react';
import { toast } from 'sonner';

const STATUSES = ['Scheduled', 'In Progress', 'Completed', 'Delayed', 'Cancelled'];
const SB = { Completed: 'bg-emerald-500/10 text-emerald-400', Scheduled: 'bg-blue-500/10 text-blue-400', 'In Progress': 'bg-amber-500/10 text-amber-400', Delayed: 'bg-red-500/10 text-red-400', Cancelled: 'bg-gray-500/10 text-gray-400', Pending: 'bg-gray-500/10 text-gray-400' };

export default function Deliveries() {
  const ctx = useOutletContext();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('');

  useEffect(() => { adminApi.getDeliveries().then(d => { setData(d); setLoading(false); }); }, []);
  const filtered = filter ? data.filter(p => p.status === filter) : data;

  if (loading) return <div className="flex items-center justify-center h-64"><Loader2 className="w-8 h-8 animate-spin text-blue-400" /></div>;

  return (
    <div data-testid="admin-deliveries">
      <h1 className="text-2xl font-bold mb-1" style={{ fontFamily: 'Chivo, sans-serif' }}>Delivery Dashboard</h1>
      <p className={`text-sm ${ctx.textSecondary} mb-6`}>{data.length} deliveries</p>

      <div className="flex flex-wrap gap-2 mb-4">
        <button onClick={() => setFilter('')} className={`px-3 py-1.5 rounded-full text-xs font-medium ${!filter ? 'bg-blue-600 text-white' : `${ctx.hoverBg} ${ctx.textSecondary}`}`}>All ({data.length})</button>
        {STATUSES.map(s => { const c = data.filter(p => p.status === s).length; return c > 0 && (
          <button key={s} onClick={() => setFilter(s)} className={`px-3 py-1.5 rounded-full text-xs font-medium ${filter === s ? 'bg-blue-600 text-white' : `${ctx.hoverBg} ${ctx.textSecondary}`}`}>{s} ({c})</button>
        ); })}
      </div>

      <div className={`${ctx.cardBg} rounded-xl border ${ctx.borderColor} overflow-x-auto`}>
        <table className="w-full text-sm">
          <thead><tr className={`border-b ${ctx.borderColor}`}>
            {['Reservation', 'Student', 'School', 'Residence', 'Date', 'Time', 'Team', 'Vehicle', 'Items', 'Status'].map(h => (
              <th key={h} className={`text-left px-4 py-3 text-xs font-medium ${ctx.textSecondary} uppercase tracking-wider`}>{h}</th>
            ))}
          </tr></thead>
          <tbody>{filtered.map(d => (
            <tr key={d._id} className={`border-b ${ctx.borderColor} ${ctx.hoverBg}`}>
              <td className="px-4 py-3 font-mono text-xs">{d.reservation_number}</td>
              <td className="px-4 py-3 text-sm font-medium">{d.student_name}</td>
              <td className="px-4 py-3 text-xs">{d.school}</td>
              <td className="px-4 py-3 text-xs">{d.residence_hall}</td>
              <td className="px-4 py-3 text-xs">{d.date}</td>
              <td className="px-4 py-3 text-xs">{d.time_window}</td>
              <td className="px-4 py-3 text-xs">{d.mover_team}</td>
              <td className="px-4 py-3 text-xs">{d.vehicle}</td>
              <td className="px-4 py-3 text-center">{d.item_count}</td>
              <td className="px-4 py-3">
                <select value={d.status} onChange={e => { const s = e.target.value; adminApi.updateDeliveryStatus(d._id, s); setData(prev => prev.map(x => x._id === d._id ? {...x, status: s} : x)); toast.success(`Status → ${s}`); }}
                  data-testid={`delivery-status-select-${d._id}`}
                  className={`text-xs px-2 py-1 rounded-full border-0 outline-none cursor-pointer ${SB[d.status] || SB.Pending}`}>
                  {STATUSES.map(s => <option key={s} value={s}>{s}</option>)}
                </select>
              </td>
            </tr>
          ))}</tbody>
        </table>
      </div>
    </div>
  );
}
